import { Injectable } from '@angular/core';
import { SnackBarService } from '@core/services/snack-bar.service';
import { FileManagerService } from '@features/file-manager/services/file-manager.service';
import { ProjectModel } from '@features/projects/models/projects.models';
import { getCurrentProject, ProjectState } from '@features/projects/store/reducers/projects.reducer';
import { select, Store } from '@ngrx/store';
import { PlatformCommand } from '@shared/commands/command-base';
import { IPlatformCommandHandler, IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { DialogModel } from '@shared/models/dialog.model';
import { DialogService } from '@shared/services/dialog-service';
import { take } from 'rxjs/operators';
import { FlexSheetService } from './services/flex-sheet.service';

@Injectable({
  providedIn: 'root'
})

export class ManageEntityCommandHandler implements IPlatformCommandHandler {
  currentWorkbookId: string;
  currentProject: ProjectModel;
  constructor(
    protected dialogService: DialogService,
    private snackBarService: SnackBarService,
    private projectStore: Store<ProjectState>,
    private flexSheetService: FlexSheetService

  ) { }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    const worksheets = this.flexSheetService.worksheets;
    const isStagedWorkbook = worksheets.some(ws => ws.metaData && ws.metaData['IsStagingArea']);
    const currentWorksheet = this.flexSheetService.getCurrentWorkSheet();
    const currentWorkbook = this.flexSheetService.getCurrentWorkBook();
    const iStagedSheet = currentWorksheet.metaData && currentWorksheet.metaData['IsStagingArea'];
    if(!isStagedWorkbook) {
        this.snackBarService.showError('Current workbook is not staged');
        return false;
    }
    if(!iStagedSheet) {
      this.snackBarService.showError('Please, open a staged Work sheet');
      return false;
    }
    this.projectStore.pipe(select(getCurrentProject), take(1)).subscribe( (project: ProjectModel) => {
      if (project) {
        this.currentProject = project;
        command.fieldValues['ProjectName'] = project.Name;
        command.projectId = project.ProjectId;
      }
    });
    const dialogModel = DialogModel.create('Manage Entities', 'SpreadsheetManageEntityDialogComponent', {}, '1200px', '1200px');
    const workbookId = currentWorkbook.id;
    const worksheetId = currentWorksheet.id;
    dialogModel.input['workbookId'] = worksheetId;
    this.dialogService.showOkCancelDialog(dialogModel)
      .subscribe(actionState => {
        if (actionState && actionState.action === 'OK') {
          command.fieldValues['CurrentWorksheetId'] = worksheetId;
          command.name =  'AddEventSourceModelCommand'
          command.fieldValues['CommandName'] = 'ManageEntityCommand';
          command.fieldValues['EventSourceId'] = command.fieldValues['WorkbookSetId'];
          command.fieldValues['SourceType'] = 'WorkbookSet';
          handler.executeCommand(command);
        }
      });
      return true;
   }

}
